import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15d283a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-test": "jyre-recommends-page",
  class: "home-page text-big"
}
const _hoisted_2 = { class: "center-flex" }
const _hoisted_3 = { class: "homepage-content-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from "vue";
import { useRoute } from "vue-router";
import { UserDetailsApiModel } from "../api-models";
import { csContext } from "../services/cs-context";
import HomePageHeader from "../components/home-page-header.vue";
import SmartSearchBar from "../components/smart-search/smart-search-bar.vue";
import SmartSearch from "../components/smart-search/smart-search.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'jyre-recommends',
  setup(__props) {

const route = useRoute();

const user = ref<UserDetailsApiModel>(csContext.user);
const userQuery = ref<string>(route.query.question as string);

function goToJyreRecommends(query: string): void {
  const encodedQueryString = encodeURIComponent(query);
  window.location.href = `/jyrerecommends?question=${encodedQueryString}`;
}

return (_ctx: any,_cache: any) => {
  return (!!user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(HomePageHeader, {
              "first-name": user.value.firstName
            }, null, 8, ["first-name"]),
            _createVNode(SmartSearchBar, {
              onRun: goToJyreRecommends,
              question: userQuery.value
            }, null, 8, ["question"]),
            _hoisted_4,
            _createVNode(SmartSearch, { query: userQuery.value }, null, 8, ["query"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})